module.exports = __webpack_public_path__ + "static/media/dontKnow.730a5547.png";